import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { BaseHttpService } from '../../../base/base-http.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { SessionWrapperService } from '../../../session/session-wrapper.service';
import { IEmployee } from '../../../../models/self-services/employees/employee';
import { listResponseModel, ResponseModel, SingleResponseModel } from '../../../../models/base/base';

@Injectable({
  providedIn: 'root'
})
export class EmployeeService extends BaseHttpService<IEmployee> {
  baseUrl = environment.baseUrlHR + this.getResourceUrl();
  constructor(
    private httpClient: HttpClient,
    private sessionService: SessionWrapperService
  ) {
    super(httpClient);
  }

  getResourceUrl(): string {
    return 'Employee';
  }

  
    genderData = [{ code: 0, genederaraname: 'ذكر', genderlatname: 'male' },
    { code: 1, genederaraname: 'أنثى', genderlatname: 'female' }
    ]
  
    religionData = [{ code: 0, religionaraname: 'مسلم', religionlatname: 'muslim' },
    { code: 1, religionaraname: 'غير مسلم', religionlatname: 'not a muslim' }
    ]

  getEmlpoyee(id: string): Observable<IEmployee> {
    return this.httpClient.get<IEmployee>(`${this.baseUrl}/GetbyidWithDetails?id=${id}`);
  }
  getEmlpoyeeId(userid: string): Observable<string> {
    return this.httpClient.get<string>(`${this.baseUrl}/GetbyUserId?userid=${userid}`);
  }

  updateContactInfo(data) {
    return this.httpClient.post(`${this.baseUrl}/UpdateEmployeeContactInfo`, data);
  }

  // employee = new BehaviorSubject<any>('');
  // employeeId = new BehaviorSubject<string>(null);

  employee = new BehaviorSubject<IEmployee>(null);
  getEmlpoyeeData() {
    const empid = this.sessionService.getEmpId();
    this.getEmlpoyee(empid).subscribe({
      next: (res) => {
        this.employee.next(res);
      }
    });
  }

   get(id: any): Observable<SingleResponseModel<IEmployee>> {
      let params = { id: id };
      return this.httpClient.get<SingleResponseModel<IEmployee>>(`${this.baseUrl}/Getbyid`, { params: params });
    }

    getByEmpCode(empCode: number): Observable<SingleResponseModel<IEmployee>> {
      return this.httpClient.get<SingleResponseModel<IEmployee>>(`${this.baseUrl}/GetByEmpCode?empCode=${empCode}`);
    }
    getAlldatebyFilter(params = null): Observable<ResponseModel<IEmployee>> {
      let request = `${this.baseUrl}/Getalldatabyfilter`;
      if (params) return this.http.get<ResponseModel<IEmployee>>(request, { params: params });
      else return this.http.get<ResponseModel<IEmployee>>(request);
    }
}
